import { createGlobalStyle } from 'styled-components';
import Fonts, { Font, FontWeight } from '../utils/fonts';
import Color from '../utils/colors';

const GlobalStyles = createGlobalStyle`
    ${Fonts}

    body {
        ${Font.PRIMARY};
        ${FontWeight.REGULAR};
        color: ${Color.TEXT_PRIMARY};

        margin: 0;
    }

    html {
        box-sizing: border-box;
    }

    *, *:before, *:after {
        box-sizing: inherit;
    }
`;

export default GlobalStyles;
